import SubjectService from '../../services/subject.service'
import {
	SET_ACCOUNT_SUBJECTS,
	FILTER_ACCOUNT_SUBJECTS,
	SET_PUBLIC_SUBJECTS,
} from './'

const setPublicSubjects: any = (payload: any) => {
	return async (dispatch: any) => {
		await SubjectService.getSubjects(payload)
			.then((response) => {
				dispatch({
					type: SET_PUBLIC_SUBJECTS,
					response: response,
				})
			})
			.catch((error) => console.log(error))
	}
}

const setAccountSubjects: any = (payload: any, filter: boolean = false) => {
	return async (dispatch: any) => {
		await SubjectService.getSubjects(payload)
			.then((response) => {
				if (!filter) {
					dispatch({
						type: SET_ACCOUNT_SUBJECTS,
						response: response,
					})
					return
				}
				dispatch({
					type: FILTER_ACCOUNT_SUBJECTS,
					response: response,
				})
			})
			.catch((error) => console.log(error))
	}
}

export { setAccountSubjects, setPublicSubjects }
